import React from 'react';

import { useConfiguration } from '../../context/configurationContext';
import { useIntl } from '../../util/reactIntl';

import CMSPage from '../CMSPage/CMSPage';

/**
 * Render the complete hosted buyer-protection content on the canonical short URL.
 *
 * @param {Object} props - Route props
 * @returns {JSX.Element}
 */
const BuyerProtectionCMSPage = props => {
  const intl = useIntl();
  const config = useConfiguration();
  const marketplaceName = config.marketplaceName;
  const title = intl.formatMessage({ id: 'BuyerProtectionPage.schemaTitle' }, { marketplaceName });
  const description = intl.formatMessage(
    { id: 'BuyerProtectionPage.schemaDescription' },
    { marketplaceName }
  );

  return <CMSPage {...props} pageId="kaeuferschutz" title={title} description={description} />;
};

export default BuyerProtectionCMSPage;
